import React, {startTransition, useEffect, useState} from 'react';
import {ConfigApi, OrderType} from "../../../../../../../../../services/Api/types";
import {api} from "../../../../../../../../../services/Api/api";
import {MenuState} from "../../../../../../../../../services/Menu/types";
import LoadingContainer from "../../../../../../../../../components/Common/LoadingContainer";
import {RootState} from "../../../../../../../../../../reducers";
import {selectLocale} from "../../../../../../../../../services/Session/reducer";
import {connect} from "react-redux";
import {getParsedMultistoreMenuCategories, getParsedMultistoreMenus} from "../../../../../../../utils/multistoreMenu";
import {MultistoreMenuCategory, MultistoreMenuItem} from "../../../../../../../utils/types";
import MultistoreMenu from "./MultistoreMenu";
import MultistoreMenuOrderTypesModal from "./MultistoreMenuOrderTypesModal";

interface OwnProps {
    config: ConfigApi | undefined;
    orderTypes: OrderType[];
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const MultistoreWithMapHomePageMenuSection = ({config, locale, orderTypes}: Props) => {
    const [menuLoading, setMenuLoading] = useState(false);
    const [menus, setMenus] = useState<MenuState | undefined>();
    const [categories, setCategories] = useState<MultistoreMenuCategory[]>([]);
    const [menu, setMenu] = useState<Record<string, any> | undefined>();
    const [selectedProduct, setSelectedProduct] = useState<MultistoreMenuItem | undefined>();

    useEffect(() => {
        fetchMenu()
    }, []);

    useEffect(() => {
        startTransition(() => {
            if (!menu) return;

            const parsed = getParsedMultistoreMenuCategories(
                menu,
                menus?.categories ?? [],
                locale ?? "",
                menus?.items ?? [],
                menus?.item_groups ?? [],
            );

            if (parsed) {
                const withItems = parsed.filter(item => item.items.length > 0);
                setCategories(withItems);
            }

        });
    }, [menu?.id]);

    const fetchMenu = async () => {
        try {
            setMenuLoading(true);
            const res = await api.getMenus(locale);
            setMenus(res);

            if (res.menus.length > 0) {
                const sortedMenus = [...res.menus.sort((a: Record<string, any>, b: Record<string, any>) => a.name.localeCompare(b.name))];
                setMenu(sortedMenus[0]);
            }
        } catch (error) {

        } finally {
            setMenuLoading(false);
        }
    }

    if (menuLoading) return <LoadingContainer/>;

    if (!menus || menus.menus.length === 0) return <></>;

    return (
        <div className="multistore-with-map-home-page-menu-section">
            <MultistoreMenu config={config} menus={getParsedMultistoreMenus(menus.menus, locale)} menuId={menu!.id}
                            categories={categories} setMenu={setMenu} setSelectedProduct={setSelectedProduct}/>
            {!!selectedProduct && (
                <MultistoreMenuOrderTypesModal orderTypes={orderTypes} show={!!selectedProduct}
                                               onHide={() => setSelectedProduct(undefined)}
                                               selectedProduct={selectedProduct}/>
            )}
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    locale: selectLocale(state.session)
})

const connector = connect(mapStateToProps);

export default connector(MultistoreWithMapHomePageMenuSection);